module.exports = __webpack_public_path__ + "static/media/chart-background.d6ff147a.png";